import React, { useEffect, useCallback, useRef, useState } from "react";
import { Link } from "react-router-dom";
import removeItemPic from "./../assets/remove.png";
import xButton from "./../assets/xButton.png";
import restaurantList from "./../restaurants/restaurantsList";
import restaurantListHe from "./../restaurants/restaurantsListHe";
import firebase from "./../../config/fbConfig.js";
import Paypal from "./../Paypal/Paypal";
import cartPic from "./../assets/cart.png";
import goBack from "./../assets/back.png";

const analytics = firebase.analytics();
const LiveDB = firebase.database();
const db = firebase.firestore();

function Cart({ cart, setCart, closeSuccessToast, forceUpdate }) {
	const selectRestValue = useRef(); // used to track the user's pick regarding which restaurant
	const selectedTimeValue = useRef(); // used to track the user's pick regarding which time he wants the delivery/takeaway
	const fullName = useRef();
	const phoneNum = useRef();
	const address = useRef();
	const [paidFor, setPaidFor] = useState(false);
	const [trackURL, setTrackURL] = useState(null);
	const selectPayment = useRef();
	let [userRequest, setUserRequest] = useState({ service: false, restaurant: null, chosenTime: 0, state: 0 });
	const product = useRef({ finishedRender: false });

	// Used when the user wants to open my cart element
	let showCart = () => {
		document.getElementById("cartDetails").classList.add("active");
		document.getElementById("brightnessBottom").classList.add("active");
		closeSuccessToast();
	};
	// Used when the user is closing the mycart element
	let closeCart = (e) => {
		document.getElementById("cartDetails").classList.remove("active");
		document.getElementById("brightnessBottom").classList.remove("active");
		document.getElementById("cartWrapper").style.display = "block";
		document.getElementById("nextStep").style.display = "none";
		document.getElementById("selectWish").selectedIndex = 0;

		if (cart.noDelivery != null && cart.noDelivery != false) document.getElementById("deliveryErr").style.display = "none";
		if (cart.times.length > 0) document.getElementById("pickRestaurant").style.display = "none";
		if (document.getElementById("makePayment").style.display == "block") document.getElementById("makePayment").style.display = "none";
	};
	// Used when the user wants to remove this specific item from his cart (clicking on the X button next to the product)
	let removeThisItem = (index) => {
		if (window.location.href.includes("/en")) {
			if (!window.confirm("Are you sure you want to remove this item?")) return;
		} else {
			if (window.confirm("האם אתה בטוח שברצונך למחוק את הפריט הזה מהסל הקניות שלך?")) {
				// For Analytics, getting the removed item and logging this event
				let cartLog = Object.assign({}, cart.products[index]);
				let arr = [];
				cartLog.extras.forEach((extra) => {
					arr.push(extra.name);
				});
				cartLog.extras = arr;
				analytics.logEvent("removed_from_cart", cartLog);

				// Actually removing this item from cart
				cart.totalPrice = cart.totalPrice - cart.products[index].totalPrice;
				cart.products.splice(index, 1);
				cart.counter--;

				setCart(cart);
				forceUpdate();
			}
		}
	};
	// Used when the user wants to go to the next step/part after his cart seems fine(moving to selecting service)
	let proceedNextStep = () => {
		document.getElementById("cartWrapper").style.display = "none";
		document.getElementById("nextStep").style.display = "block";
		// This is used to process whether cart's items are deliverable
		cart.noDelivery = checkDelivery();
		getTimesEvery15Mins(); // Used to get an array of all 15 mins available (for choosing a time for delivery)
		setCart(cart);
		forceUpdate();
	};
	// Used to check if the items are available for delivery
	let checkDelivery = () => {
		let noDelivery = {};
		let counter = 0;
		let allNamesWithoutDelivery = [];
		for (let i = 0; i < cart.products.length; i++) {
			if (cart.products[i].noDelivery) {
				allNamesWithoutDelivery.push(cart.products[i].name);
				counter++;
			}
		}

		if (allNamesWithoutDelivery.length > 0) {
			noDelivery = { names: allNamesWithoutDelivery.join(", "), counter: counter };
		} else {
			noDelivery = false;
		}
		return noDelivery;
	};
	// Used when the user wants to go back from services section back to his cart
	let goBackCart = (e) => {
		if (e.target.parentNode.id === "nextStep") {
			document.getElementById("cartWrapper").style.display = "block";
			document.getElementById("nextStep").style.display = "none";
		} else {
			document.getElementById("cartWrapper").style.display = "block";
			document.getElementById("pickRestaurant").style.display = "none";
		}
	};
	// Used when the user picks delivery, and the items arent deliverable
	let showErrNoDelivery = (val) => {
		if (cart.noDelivery != null && cart.noDelivery != false) {
			if (val === "Delivery") {
				document.getElementById("deliveryErr").style.display = "block";
			} else {
				document.getElementById("deliveryErr").style.display = "none";
			}
		}
	};
	// Used when the user wants to go to the next part click to move from services selection to restaurant selection
	let processFinalPart = (selectValue) => {
		if (window.location.href.includes("/en")) {
			if (selectValue === 0) {
				alert("You haven't picked any service yet.");
				return;
			}
			if (cart.noDelivery != null && cart.noDelivery != false && selectValue === 2) {
				alert("You can't proceed to the next part,\n because your items aren't deliverable.");
				return;
			}
		} else {
			if (selectValue === 0) {
				alert("לא בחרת בסוג שירות מבוקש.");
				return;
			}
			if (cart.noDelivery != null && cart.noDelivery != false && selectValue === 2) {
				alert("את/ה לא יכול/ה להמשיך לשלב הבא,\n משום שהפריטים שאתה מנסה להזמין לא זמינים למשלוח.");
				return;
			}
		}

		userRequest.service = selectValue;

		let extrasString = "";
		let nameOptions = "";
		cart.products.forEach((product) => {
			let addedString = "";
			if (product.options.length != 0) addedString = "(" + product.options.join(", ") + "), ";
			else {
				addedString = ", ";
			}
			nameOptions += product.name + addedString;
			product.extras.forEach((extra) => {
				extrasString += extra.name + ", ";
			});
		});
		nameOptions = nameOptions.substring(0, nameOptions.length - 2);
		if (extrasString !== "") {
			if (window.location.href.includes("/en")) {
				extrasString = "Extras: " + extrasString.substring(0, extrasString.length - 2) + ".";
			} else {
				// Else call Extras in english
				extrasString = "תוספות: " + extrasString.substring(0, extrasString.length - 2) + ".";
			}
		} else {
			extrasString = "No extras.";
		}
		product.current = { price: cart.totalPrice, name: nameOptions, extras: extrasString, finishedRender: true, captureID: null };

		setUserRequest(userRequest);
		forceUpdate();
		document.getElementById("nextStep").style.display = "none";
		document.getElementById("pickRestaurant").style.display = "block";
	};
	// Used to get the proper service name, because it's defined by numbers for firebase optimization
	let getNameService = (service) => {
		if (window.location.href.includes("/en")) {
			if (service == 1) return "Takeaway";
			if (service == 2) return "Delivery";
			if (service == 3) return "Table Reserveation";
		} else {
			if (service == 1) return "טייק-אווי";
			if (service == 2) return "משלוח";
			if (service == 3) return "שולחן מוכן";
		}
	};
	// Used when the user clicks on a restuarnt on pick services element, to show the restaurant he picked
	let showSelectedRest = (index) => {
		userRequest.restaurant = index;
		setUserRequest(userRequest);
		forceUpdate();
	};
	let getTimesEvery15Mins = () => {
		// That's 900000 because 15 mins in miliseconds is 900000
		let time = new Date(Math.ceil(new Date().getTime() / 900000) * 900000);
		let x = [time];
		for (let i = 0; i < 10; i++) {
			time = new Date(Math.ceil(time.getTime() / 900000) * 900000 + 900000);

			let hours = "";
			let minutes = "";

			if (time.getHours() < 10) {
				hours = "0" + time.getHours();
			} else {
				hours = time.getHours();
			}
			if (time.getMinutes() < 10) {
				minutes = "0" + time.getMinutes();
			} else {
				minutes = time.getMinutes();
			}

			x.push(`${hours}:${minutes}`);
		}
		cart.times = x;
	};
	let addHyphen = (e) => {
		let targ = e.target;
		let key = e.key;
		let event = e;
		if ((key >= "0" && key <= "9") || key == "Backspace") {
			setTimeout(() => {
				if (targ.value.length === 3 && key != "Backspace") {
					targ.value = targ.value + "-";
				}
				if (key == "Backspace" && targ.value.length === 3) {
					targ.value = targ.value.substring(0, 2);
				}
			});

			if (targ.value.length > 10) {
				if (key !== "Backspace") {
					event.preventDefault();
				}
			}
		} else {
			event.preventDefault();
		}
	};
	// Used when the user wants to move to next step from service pick to handling payment(So getting all the detalis he filled in an saving them in userRequest)
	let executeRequest = (name, phone, address) => {
		if (window.location.href.includes("/en")) {
			if (name === "" || phone === "") {
				alert("You haven't filled in your name / phone number.");
				return;
			}

			if (address != undefined) {
				if (address === "") {
					alert("You must enter your address.");
					return;
				}
			}

			if (userRequest.chosenTime === 0) {
				alert("You haven't picked time.");
				return;
			}
			if (userRequest.restaurant === null) {
				alert("You haven't picked a restaurant.");
				return;
			}
		} else {
			if (name === "" || phone === "") {
				alert("לא מילאת את השם המלא / מספר פלאפון שלך.");
				return;
			}

			if (address != undefined) {
				if (address === "") {
					alert("עליך להכניס כתובת מגורים.");
					return;
				}
			}

			if (userRequest.chosenTime === 0) {
				alert("לא בחרת זמן הגעה.");
				return;
			}
			if (userRequest.restaurant === null) {
				alert("לא בחרת במסעדה הרצויה.");
				return;
			}
		}

		userRequest.fullName = name;
		userRequest.phoneNum = phone;
		if (userRequest.service == "Delivery") {
			userRequest.address = address;
		}

		let timestamp = firebase.firestore.Timestamp.fromDate(new Date()).seconds;

		userRequest.timestamp = timestamp;
		userRequest.cart = cart;

		document.getElementById("pickRestaurant").style.display = "none";
		document.getElementById("makePayment").style.display = "block";
	};

	// Used when the user changing the value of the Select element (choosing between Cash and Paypal / Credit card)
	let handlePaymentPick = (value) => {
		if (value === "Paypal") {
			document.getElementById("paypalPayment").style.display = "block";
			document.getElementById("cashout").style.display = "none";
			document.getElementById("makePayment").style.paddingBottom = "15px";
		} else {
			document.getElementById("paypalPayment").style.display = "none";
			document.getElementById("cashout").style.display = "block";
			document.getElementById("makePayment").style.paddingBottom = "70px";
		}
	};
	let handleCash = () => {
		if (selectPayment.current.value != "Cash") {
			alert("lol you really tried that");
			return;
		}
		alert("Pay with cash is just for demo for now because it isn't a real restaurant.\nPaypal payment is working.");
	};

	// Used to defined whether the user successfully paid for his cart
	useEffect(() => {
		if (paidFor) {
			// For Analytics after every purchase completed
			analytics.logEvent("purchase_completed", {
				fullName: userRequest.fullName,
				phoneNum: userRequest.phoneNum,
				timeChosen: userRequest.chosenTime,
				totalPrice: product.current.price,
				items: product.current.name,
				extras: product.current.extras,
			});

			setStatistics(userRequest.cart.products, userRequest.restaurant, userRequest.phoneNum);
			let newPostKey = LiveDB.ref().child("orders").push().key;
			let updates = {};

			let optimizedRequest = OptimizeObject(userRequest);
			optimizedRequest.i = product.current.captureID; // Storing the capture id for future refund request

			updates["/orders/" + newPostKey] = optimizedRequest;
			LiveDB.ref().update(updates);

			setTrackURL(newPostKey + Math.round(Math.random() * 9).toString() + Math.round(Math.random() * 9) + Math.round(Math.random() * 9).toString());
			// Using 3 random numbers after to ensure security, then cutting these 3 numbers in orderInfo component, to get the actual ID

			optimizedRequest.id = newPostKey;
			optimizedRequest = JSON.stringify(optimizedRequest);

			localStorage.setItem("myOrder", optimizedRequest);
		}
	}, [paidFor]);

	let getOptimizedCart = (arr) => {
		let getOptimizedExtras = (extras) => {
			let newArr = [];
			let obj = {};
			for (let i = 0; i < extras.length; i++) {
				obj.n = extras[i].name;
				obj.p = extras[i].price;
				newArr.push(obj);
				obj = {};
			}
			return newArr;
		};

		let newArr = [];
		let obj = {};

		for (let i = 0; i < arr.length; i++) {
			obj.n = arr[i].name;
			obj.p = arr[i].price;
			obj.t = arr[i].totalPrice;
			obj.o = arr[i].options.length != 0 ? arr[i].options : null;
			obj.e = getOptimizedExtras(arr[i].extras).length != 0 ? getOptimizedExtras(arr[i].extras) : null;
			newArr.push(obj);
			obj = {};
		}
		return newArr;
	};

	let OptimizeObject = (obj) => {
		let x = {
			s: obj.service,
			r: obj.restaurant,
			x: obj.chosenTime, // because this is the 1 before last letter and easy to remember
			z: obj.state, // because this is the last letter and most important to remember
			n: obj.fullName,
			q: obj.phoneNum, // because all other letters are occupied already
			a: obj.address != undefined ? obj.address : null,
			t: obj.timestamp,
			c: getOptimizedCart(obj.cart.products),
			p: obj.cart.totalPrice,
		};
		return x;
	};
	// Setting statistics in Firebase database according to the user's cart (BestProduct, bestBuyer, BestRestaurant)
	let setStatistics = (products, rest, phoneNum) => {
		db.collection("statistics")
			.doc("orders")
			.get()
			.then((doc) => {
				let statistics = doc.data().orders;

				function setBestProduct(products) {
					for (let product of products) {
						let index = bestProduct.findIndex((i) => i.name === product.name);
						if (index == -1) {
							bestProduct.push({
								name: product.name,
								price: product.price,
								counter: 1,
							});
						} else {
							bestProduct[index].counter++;
						}
					}
				}
				let bestProduct = statistics[statistics.length - 1].bestProduct;
				setBestProduct(products);
				let bestRest = statistics[statistics.length - 1].bestRest;
				bestRest[rest].counter++;
				let bestBuyer = statistics[statistics.length - 1].bestBuyer;
				let indexP = bestBuyer.findIndex((i) => i.phoneNum === phoneNum);
				if (indexP == -1) {
					bestBuyer.push({
						phoneNum: phoneNum,
						counter: 1,
					});
				} else {
					bestBuyer[indexP].counter++;
				}
				let totalGain = statistics[statistics.length - 1].totalMoney;

				statistics[statistics.length - 1] = {
					bestProduct: bestProduct,
					bestRest: bestRest,
					bestBuyer: bestBuyer,
					timestamp: statistics[statistics.length - 1].timestamp,
					totalMoney: totalGain + +cart.totalPrice,
				};

				db.collection("statistics").doc("orders").set({
					orders: statistics,
				});
			});
	};
	// Allowing the user to copy the link of the TrackURL
	let copyURL = (e) => {
		window.navigator.clipboard.writeText(e.target.href);
	};

	if (window.location.href.includes("/en")) {
		return (
			<React.Fragment>
				<div id="brightnessBottom"></div>
				<div id="successAdded" hidden>
					<span id="closeToast" tabIndex="0" onClick={closeSuccessToast}>
						&times;
					</span>
					<span id="text">Successfully added to cart!</span>
				</div>

				<div id="cart" onClick={showCart}>
					<span>My Cart</span>
					<div className="counterCartWrapper">
						<span>{cart.counter}</span>
					</div>
					<img src={cartPic} alt="my cart" />
				</div>

				<div id="cartDetails">
					<img id="closeCart" onClick={closeCart} src={xButton} alt="close button" />
					<div id="cartWrapper">
						<div>Your Cart List</div>
						{cart.counter > 0 ? (
							<span>So far you've added {cart.counter} items to your cart.</span>
						) : (
							<span style={{ display: "inline-block", marginTop: "10px" }}>
								You haven't added anything to your cart yet.{" "}
								<span role="img" aria-label="sad :(">
									😢
								</span>
							</span>
						)}
						{cart.counter > 0 && (
							<React.Fragment>
								<ul>
									<li style={{ fontWeight: "900" }}>
										PRODUCT
										<span>PRICE</span>
									</li>
									{cart.products.map((product, index) => (
										<li key={product.name + index}>
											<div className="CartNameProduct">
												<div className="cartNameWrapper">
													{product.name}
													{product.options.length !== 0 && <div> ({product.options.join(", ")}) </div>}
												</div>
												<div className="specificPriceCart">{product.price}</div>
												<img src={removeItemPic} className="removeItemPic" alt="remove item" onClick={() => removeThisItem(index)} />
											</div>

											{product.extras.length != 0 && (
												<ul className="extrasAdded">
													<div>Extras added:</div>
													{product.extras.map((extraName, index) => (
														<li key={extraName + index}>
															<div className="extraName">{extraName.name}</div>
															<span className="priceExtra">{extraName.price}</span>
														</li>
													))}
													<div className="TotalPrice">
														Total Price For This Item: <span>{product.totalPrice}</span>
													</div>
												</ul>
											)}
										</li>
									))}
								</ul>
								<div className="totalPriceCart">
									Total Price For Whole Items: <span>{cart.totalPrice}</span>
								</div>
								<button className="proceedNextStep" onClick={proceedNextStep}>
									Proceed to the next step
								</button>
							</React.Fragment>
						)}
					</div>
					<div id="nextStep" style={{ display: "none" }}>
						<img className="goBackCart" src={goBack} onClick={goBackCart} alt="go back" />
						<div className="titleNextStep">Picking your service</div>

						<div className="infoCollectedWrapper">
							{" "}
							According to your cart,
							<div className="totalPriceCart">
								the total price for whole items is: <span>{cart.totalPrice}</span>
							</div>
							<div>Select your wish</div>
							<select id="selectWish" defaultValue={"nothing"} ref={selectRestValue} onChange={() => showErrNoDelivery(selectRestValue.current.value)}>
								<option disabled value="nothing">
									{" "}
									-- select an option --{" "}
								</option>
								<option value="Takeaway">Takeaway</option>
								<option value="Delivery">Delivery</option>
								<option value="Table Reservation">Table Reservation</option>
							</select>
							{cart.noDelivery != null && cart.noDelivery != false && cart.noDelivery.counter == 1 && (
								<div id="deliveryErr" role="alert" style={{ display: "none" }}>
									You try to order {cart.noDelivery.counter} item that isn't available for delivery:
									<div>{cart.noDelivery.names}</div>
								</div>
							)}
							{cart.noDelivery != null && cart.noDelivery != false && cart.noDelivery.counter > 1 && (
								<div id="deliveryErr" role="alert" style={{ display: "none" }}>
									You try to order {cart.noDelivery.counter} items that aren't available for delivery:
									<div>{cart.noDelivery.names}</div>
								</div>
							)}
						</div>

						<button className="proceedNextStep" onClick={() => processFinalPart(selectRestValue.current.selectedIndex)}>
							Proceed to the next step
						</button>
					</div>
					<div id="pickRestaurant" style={{ display: "none" }}>
						<img className="goBackCart" src={goBack} onClick={goBackCart} alt="go back" />
						<div className="titleNextStep">Fill in the details below to continue:</div>
						<span className="totalPriceCart">
							You've picked: {getNameService(userRequest.service)} (Total Payment: <span>{cart.totalPrice})</span>
						</span>
						<form>
							<label htmlFor="fullName" required>
								Full Name: <span style={{ color: "red" }}>*</span>
							</label>
							<input type="text" id="fullName" name="fullName" ref={fullName} />
							<label htmlFor="phoneNum" required>
								Phone Number: <span style={{ color: "red" }}>*</span>
							</label>
							<input type="text" id="phoneNum" name="phoneNum" ref={phoneNum} onKeyDown={addHyphen} />

							{userRequest.service === 2 && (
								<React.Fragment>
									<label htmlFor="address" required>
										Address: <span style={{ color: "red" }}>*</span>
									</label>
									<input type="text" id="address" name="address" ref={address} />
								</React.Fragment>
							)}

							{userRequest.service !== 2 ? (
								<label htmlFor="timeComing" required>
									So when are you coming? <span style={{ color: "red" }}>*</span>
								</label>
							) : (
								<label htmlFor="timeComing" required>
									Select delivery time<span style={{ color: "red" }}>*</span>
								</label>
							)}

							<select id="timeComing" defaultValue={"nothing"} ref={selectedTimeValue} onChange={() => (userRequest.chosenTime = selectedTimeValue.current.value)}>
								<option disabled value="nothing">
									{" "}
									-- time --{" "}
								</option>

								{cart.times.slice(1).map((val) => (
									<option value={val} key={val}>
										{val}
									</option>
								))}
							</select>
						</form>
						<label style={{ paddingTop: "15px" }}>
							Select a restaurant: <span style={{ color: "red" }}>*</span>{" "}
							{userRequest.restaurant != null && <div> (You selected: {restaurantList[userRequest.restaurant].title}) </div>}
						</label>
						<ul id="restaurantsList">
							{restaurantList.map((val, index) => (
								<li key={index} onClick={() => showSelectedRest(index)}>
									<img src={"/assets/restaurants/" + val.name} draggable="false" alt={val.title + " restaurant"} />
									<div>
										<div>{val.title}</div>
										<img src="/assets/restaurants/map.png" alt="location" />
										<div className="address">{val.addressNoHTML}</div>
									</div>
								</li>
							))}
						</ul>

						{userRequest.service === 1 && (
							<button className="proceedNextStep" onClick={() => executeRequest(fullName.current.value, phoneNum.current.value)}>
								Handle payment
							</button>
						)}
						{userRequest.service === 2 && (
							<button className="proceedNextStep" onClick={() => executeRequest(fullName.current.value, phoneNum.current.value, address.current.value)}>
								Handle payment
							</button>
						)}
						{userRequest.service === 3 && (
							<button className="proceedNextStep" onClick={() => executeRequest(fullName.current.value, phoneNum.current.value)}>
								Make a reservation
							</button>
						)}
					</div>
					<div id="makePayment" style={{ display: "none" }}>
						{!paidFor && (
							<React.Fragment>
								<div className="titleNextStep">Handling Payment</div>
								<ul>
									<li style={{ fontWeight: "900" }}>
										PRODUCT
										<span>PRICE</span>
									</li>
									{cart.products.map((product, index) => (
										<li key={product.name + index}>
											<div className="CartNameProduct">
												<div className="cartNameWrapper">
													{product.name}
													{product.options.length != 0 && <div> ({product.options.join(", ")}) </div>}
												</div>
												<div className="specificPriceCart">{product.price}</div>
											</div>

											{product.extras.length != 0 && (
												<ul className="extrasAdded">
													<div>Extras added:</div>
													{product.extras.map((extraName, index) => (
														<li key={extraName + index}>
															<div className="extraName">{extraName.name}</div>
															<span className="priceExtra">{extraName.price}</span>
														</li>
													))}
													<div className="TotalPrice">
														Total Price For This Item: <span>{product.totalPrice}</span>
													</div>
												</ul>
											)}
										</li>
									))}
								</ul>
								<div className="totalPriceCart">
									Total Price For Whole Items: <span>{cart.totalPrice}</span>
								</div>
								{userRequest.service !== 2 && <div>Please pick your payment method.</div>}

								{userRequest.service !== 2 && (
									<select defaultValue={"nothing"} ref={selectPayment} onChange={() => handlePaymentPick(selectPayment.current.value)}>
										<option disabled value="nothing">
											{" "}
											-- method --{" "}
										</option>
										<option value="Cash">Cash</option>
										<option value="Paypal">Paypal / Credit Card</option>
									</select>
								)}
							</React.Fragment>
						)}

						{userRequest.service !== 2 ? (
							<React.Fragment>
								<div id="paypalPayment" style={{ display: "none" }}>
									<Paypal product={product.current} paidFor={paidFor} setPaidFor={setPaidFor} />
								</div>
								<button id="cashout" className="proceedNextStep" onClick={handleCash} style={{ display: "none" }}>
									Pay With Cash
								</button>
							</React.Fragment>
						) : (
							<div id="paypalPayment">
								<Paypal product={product.current} paidFor={paidFor} setPaidFor={setPaidFor} />
							</div>
						)}

						{trackURL != null && (
							<React.Fragment>
								<span style={{ display: "inline-block", paddingTop: "25px", display: "flex", paddingLeft: "35px", borderTop: "2px dashed black", marginTop: "30px" }}>
									Click this link to track your order:
								</span>
								<div id="trackURLAccepted">
									<Link to={"/en/order/" + trackURL} onClick={copyURL}>
										<div>Click here to track/cancel your order.</div>
										<div>
											* <span>You can cancel it only as long as your request is being pending by the restaurant.</span>
										</div>
										Link will be copied to your clipboard.
									</Link>
								</div>
							</React.Fragment>
						)}
					</div>
				</div>
			</React.Fragment>
		);
	}

	// Else render it in Hebrew
	return (
		<React.Fragment>
			<div id="brightnessBottom"></div>
			<div id="successAdded" hidden>
				<span id="closeToast" tabIndex="0" onClick={closeSuccessToast}>
					&times;
				</span>
				<span id="text" className="hebrew">
					נוסף בהצלחה לסל הקניות שלי!
				</span>
			</div>

			<div id="cart" onClick={showCart}>
				<span>סל קניות</span>
				<div className="counterCartWrapper">
					<span>{cart.counter}</span>
				</div>
				<img src={cartPic} alt="my cart" />
			</div>

			<div id="cartDetails">
				<img id="closeCart" onClick={closeCart} src={xButton} alt="close button" />
				<div id="cartWrapper">
					<div>סל הקניות שלי</div>
					{cart.counter > 0 ? (
						<span>עד כה הוספת {cart.counter} פריטים לסל הקניות שלך.</span>
					) : (
						<span style={{ display: "inline-block", marginTop: "10px" }}>
							סל הקניות שלך ריק, עדיין לא הוספת שום פריט לסל.{" "}
							<span role="img" aria-label="sad :(">
								😢
							</span>
						</span>
					)}
					{cart.counter > 0 && (
						<React.Fragment>
							<ul>
								<li style={{ fontWeight: "900" }}>
									שם המנה
									<span>מחיר</span>
								</li>
								{cart.products.map((product, index) => (
									<li key={product.name + index}>
										<div className="CartNameProduct">
											<div className="cartNameWrapper">
												{product.name}
												{product.options.length !== 0 && <div> ({product.options.join(", ")}) </div>}
											</div>
											<div className="specificPriceCart">{product.price}</div>
											<img src={removeItemPic} className="removeItemPic" alt="remove item" onClick={() => removeThisItem(index)} />
										</div>

										{product.extras.length != 0 && (
											<ul className="extrasAdded">
												<div>תוספות שבחרת להוסיף:</div>
												{product.extras.map((extraName, index) => (
													<li key={extraName + index}>
														<div className="extraName">{extraName.name}</div>
														<span className="priceExtra">{extraName.price}</span>
													</li>
												))}
												<div className="TotalPrice">
													מחיר כולל של מנה זו: <span>{product.totalPrice}</span>
												</div>
											</ul>
										)}
									</li>
								))}
							</ul>
							<div className="totalPriceCart">
								מחיר סופי עבור כל הפריטים: <span>{cart.totalPrice}</span>
							</div>
							<button className="proceedNextStep" onClick={proceedNextStep}>
								המשכ/י לשלב הבא
							</button>
						</React.Fragment>
					)}
				</div>
				<div id="nextStep" style={{ display: "none" }}>
					<img className="goBackCart" src={goBack} onClick={goBackCart} alt="go back" />
					<div className="titleNextStep">בחירת השירות המבוקש</div>

					<div className="infoCollectedWrapper">
						{" "}
						לפי סל הקניות שלך,
						<div className="totalPriceCart">
							המחיר הסופי עבור כל הפריטים הוא: <span>{cart.totalPrice}</span>
						</div>
						<div style={{ display: "inline-block" }}>בחר את משאלתך</div>
						<select id="selectWish" defaultValue={"nothing"} ref={selectRestValue} onChange={() => showErrNoDelivery(selectRestValue.current.value)}>
							<option disabled value="nothing">
								{" "}
								-- בחר שירות --{" "}
							</option>
							<option value="Takeaway">טייק-אווי</option>
							<option value="Delivery">משלוח</option>
							<option value="Table Reservation">שולחן מוכן</option>
						</select>
						{cart.noDelivery != null && cart.noDelivery != false && cart.noDelivery.counter == 1 && (
							<div id="deliveryErr" role="alert" style={{ display: "none" }}>
								ניסית להזמין מוצר {cart.noDelivery.counter} שלא זמין למשלוח:
								<div>{cart.noDelivery.names}</div>
							</div>
						)}
						{cart.noDelivery != null && cart.noDelivery != false && cart.noDelivery.counter > 1 && (
							<div id="deliveryErr" role="alert" style={{ display: "none" }}>
								ניסית להזמין {cart.noDelivery.counter} מוצרים שלא זמינים למשלוח:
								<div>{cart.noDelivery.names}</div>
							</div>
						)}
					</div>

					<button className="proceedNextStep" onClick={() => processFinalPart(selectRestValue.current.selectedIndex)}>
						המשך לשלב הבא
					</button>
				</div>
				<div id="pickRestaurant" style={{ display: "none" }}>
					<img className="goBackCart" src={goBack} onClick={goBackCart} alt="go back" />
					<div className="titleNextStep">מלאו את הפרטים הבאים כדי להמשיך:</div>
					<span className="totalPriceCart">
						את/ה בחרת: {getNameService(userRequest.service)} (מחיר סופי: <span>{cart.totalPrice})</span>
					</span>
					<form>
						<label htmlFor="fullName" required>
							שם מלא: <span style={{ color: "red" }}>*</span>
						</label>
						<input type="text" id="fullName" name="fullName" ref={fullName} />
						<label htmlFor="phoneNum" required>
							מספר פלאפון: <span style={{ color: "red" }}>*</span>
						</label>
						<input type="text" id="phoneNum" name="phoneNum" ref={phoneNum} onKeyDown={addHyphen} />

						{userRequest.service === 2 && (
							<React.Fragment>
								<label htmlFor="address" required>
									כתובת מגורים: <span style={{ color: "red" }}>*</span>
								</label>
								<input type="text" id="address" name="address" ref={address} />
							</React.Fragment>
						)}

						{userRequest.service !== 2 ? (
							<label htmlFor="timeComing" required>
								אז מתי מגיעים? <span style={{ color: "red" }}>*</span>
							</label>
						) : (
							<label htmlFor="timeComing" required>
								זמן רצוי לקבלת המשלוח <span style={{ color: "red" }}>*</span>
							</label>
						)}

						<select id="timeComing" defaultValue={"nothing"} ref={selectedTimeValue} onChange={() => (userRequest.chosenTime = selectedTimeValue.current.value)}>
							<option disabled value="nothing">
								{" "}
								-- זמן --{" "}
							</option>

							{cart.times.slice(1).map((val) => (
								<option value={val} key={val}>
									{val}
								</option>
							))}
						</select>
					</form>
					<label style={{ paddingTop: "15px" }}>
						בחר מסעדה שתספק את שירותיך: <span style={{ color: "red" }}>*</span>{" "}
						{userRequest.restaurant != null && <div> (את/ה בחרת ב: {restaurantListHe[userRequest.restaurant].title}) </div>}
					</label>
					<ul id="restaurantsList">
						{restaurantListHe.map((val, index) => (
							<li key={index} onClick={() => showSelectedRest(index)}>
								<img src={"/assets/restaurants/" + val.name} draggable="false" alt={val.title + " restaurant"} />
								<div>
									<div>{val.title}</div>
									<img src="/assets/restaurants/map.png" alt="location" />
									<div className="address">{val.addressNoHTML}</div>
								</div>
							</li>
						))}
					</ul>

					{userRequest.service === 1 && (
						<button className="proceedNextStep" onClick={() => executeRequest(fullName.current.value, phoneNum.current.value)}>
							המשכ/י לתשלום
						</button>
					)}
					{userRequest.service === 2 && (
						<button className="proceedNextStep" onClick={() => executeRequest(fullName.current.value, phoneNum.current.value, address.current.value)}>
							המשכ/י לתשלום
						</button>
					)}
					{userRequest.service === 3 && (
						<button className="proceedNextStep" onClick={() => executeRequest(fullName.current.value, phoneNum.current.value)}>
							שמור מקום בשולחן
						</button>
					)}
				</div>
				<div id="makePayment" style={{ display: "none" }}>
					{!paidFor && (
						<React.Fragment>
							<div className="titleNextStep">תשלום</div>
							<ul>
								<li style={{ fontWeight: "900" }}>
									שם המנה
									<span>מחיר</span>
								</li>
								{cart.products.map((product, index) => (
									<li key={product.name + index}>
										<div className="CartNameProduct">
											<div className="cartNameWrapper">
												{product.name}
												{product.options.length != 0 && <div> ({product.options.join(", ")}) </div>}
											</div>
											<div className="specificPriceCart">{product.price}</div>
										</div>

										{product.extras.length != 0 && (
											<ul className="extrasAdded">
												<div>תוספות שבחרת להוסיף::</div>
												{product.extras.map((extraName, index) => (
													<li key={extraName + index}>
														<div className="extraName">{extraName.name}</div>
														<span className="priceExtra">{extraName.price}</span>
													</li>
												))}
												<div className="TotalPrice">
													מחיר כולל של מנה זו: <span>{product.totalPrice}</span>
												</div>
											</ul>
										)}
									</li>
								))}
							</ul>
							<div className="totalPriceCart">
								מחיר סופי עבור כל הפריטים: <span>{cart.totalPrice}</span>
							</div>
							{userRequest.service !== 2 && <div>נא לבחור את אמצעי התשלום.</div>}

							{userRequest.service !== 2 && (
								<select defaultValue={"nothing"} ref={selectPayment} onChange={() => handlePaymentPick(selectPayment.current.value)}>
									<option disabled value="nothing">
										{" "}
										-- אמצעי --{" "}
									</option>
									<option value="Cash">מזומן</option>
									<option value="Paypal">Paypal / כרטיס אשראי</option>
								</select>
							)}
						</React.Fragment>
					)}

					{userRequest.service !== 2 ? (
						<React.Fragment>
							<div id="paypalPayment" style={{ display: "none" }}>
								<Paypal product={product.current} paidFor={paidFor} setPaidFor={setPaidFor} />
							</div>
							<button id="cashout" className="proceedNextStep" onClick={handleCash} style={{ display: "none" }}>
								תשלום במזומן
							</button>
						</React.Fragment>
					) : (
						<div id="paypalPayment">
							<Paypal product={product.current} paidFor={paidFor} setPaidFor={setPaidFor} />
						</div>
					)}

					{trackURL != null && (
						<React.Fragment>
							<span style={{ display: "inline-block", paddingTop: "25px", display: "flex", paddingLeft: "35px", borderTop: "2px dashed black", marginTop: "30px" }}>
								לחץ על הלינק הבא כדי לעקוב אחרי ההזמנה שלך:
							</span>
							<div id="trackURLAccepted">
								<Link to={"/order/" + trackURL} onClick={copyURL}>
									<div>לחץ כאן כדי לעקוב/לבטל את ההזמנה שלך.</div>
									<div>
										* <span>בידיך האפשרות לבטל את ההזמנה ולקבל החזר כספי מלא כל עוד ההזמנה שלך ממתינה לאישור בידי המסעדה.</span>
									</div>
									הלינק יועתק למכשיר שלך.
								</Link>
							</div>
						</React.Fragment>
					)}
				</div>
			</div>
		</React.Fragment>
	);
}

export default Cart;
